import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data1 from "../../Data/admissionsCommittee/admissionsCommitteeData.json";
import data2 from "../../Data/admissionsCommittee/admissionsCommitteeDataRating.json";
import data3 from "../../Data/admissionsCommittee/admissionsCommitteeDataDoc.json";
import data4 from "../../Data/admissionsCommittee/admissionsCommitteeDataList.json";

export default function AdmissionsCommittee() {
  useSEO(seoConfig.admissionsCommittee);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Приемная комиссия
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        Информация для поступающих в ординатуру в 2026г.
      </h3>

      <p className="dissertation__text">
        <strong>27.07.2026г. и 28.07.2026 в 10:00</strong> состоится
        тестирование.
      </p>
      <h4 className="dissertation__caption">Место проведения:</h4>
      <p className="dissertation__text">
        Государственное бюджетное учреждение Свердловской области "Уральский
        научно-исследовательский институт дерматовенерологии и иммунопатологии",
        г. Екатеринбург, ул. Щербакова, д. 8.
      </p>

      <Accordion data={data4} />

      <h3 className="about-nii__title antiCorruption__title">
        ГБУ СО "УрНИИДВиИ" объявляет (на конкурсной основе) набор желающих
        обучаться по программам подготовки кадров высшей квалификации в
        ординатуре в (срок обучения 2 года) по специальности 31.08.32
        Дерматовенерология.
      </h3>

      <Accordion data={data2} />

      <Accordion data={data1} />

      <p className="dissertation__text">
        Обращаем внимание, что зачисление в ординатуру осуществляется с
        оригиналами документов о высшем образовании
      </p>

      <Accordion data={data3} />
    </section>
  );
}
